import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ApContentModule } from '@ap/content';
import { ApHeaderComponent } from '@ap/header';
import { ApIconComponent } from '@ap/icon';

import { BetaalverzoekComponent } from './betaalverzoek.component';
import { BetaalverzoekNavigation } from './betaalverzoek.navigation';
import { BetaalverzoekRouterModule } from './betaalverzoek.router.module';
import { APIInterceptor } from './apiInterceptor';
import { ErrorPageComponent } from './application/error-page/error-page.component';
import { FooterComponent } from './domain/footer/footer.component';

@NgModule({
    declarations: [BetaalverzoekComponent],
    imports: [
        ApContentModule,
        ApHeaderComponent,
        ApIconComponent,
        BetaalverzoekRouterModule,
        BrowserModule,
        ErrorPageComponent,
        FooterComponent
    ],
    bootstrap: [BetaalverzoekComponent],
    providers: [
        BetaalverzoekNavigation,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: APIInterceptor,
            multi: true
        }
    ]
})
export class BetaalverzoekModule {}
